module.exports = __webpack_public_path__ + "img/20200414142634216.fc77a605.png";